import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { DiagnosisReviewModelReduxPersister } from "./DiagnosisReviewPersister"
import { LabModelReduxPersister } from "./LabPersister"
import { NeurologicWeaknessReviewModelReduxPersister } from "./NeurologicWeaknessReviewPersister"
import { OncologyReviewModelReduxPersister } from "./OncologyReviewPersister"
import { PrescriptionReviewModelReduxPersister } from "./PrescriptionReviewPersister"
import { PhysicianListModelReduxPersister } from "./PhysicianListPersister"
import { DrugDisposalModelReduxPersister } from "./DrugDisposalPersister"
import { ClaimHistoryModelReduxPersister } from "./ClaimHistoryPersister"
import { UlcerReviewModelReduxPersister } from "./UlcerReviewPersister"
import { AdhocDxModelReduxPersister } from "./AdhocDxPersister"

export const createPersisters = (): ComplexModelReduxPersister[] => {
	return [
		new PhysicianListModelReduxPersister(),
		new DrugDisposalModelReduxPersister(),
		new AdhocDxModelReduxPersister(),
		new ClaimHistoryModelReduxPersister(),
		new UlcerReviewModelReduxPersister(),
		new LabModelReduxPersister(),
		// order used to matter (and maybe still does?)
		// so we'll keep it the same: load prescription review, oncology review,
		// neurologic weakness review _before_ diagnosis review
		new PrescriptionReviewModelReduxPersister(),
		new OncologyReviewModelReduxPersister(),
		new NeurologicWeaknessReviewModelReduxPersister(),
		new DiagnosisReviewModelReduxPersister(),
	]
}
